export default {"src":"/_next/static/media/search-icon-boxed.4e20560b.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};